// Upsell Products Carousel Functionality
(function () {
  "use strict";

  // Store current slide position per carousel to preserve it across re-initializations
  const carouselStates = new Map();

  function initUpsellCarousel() {
    const carouselWrapper = document.querySelector("[data-upsell-carousel]");
    if (!carouselWrapper) return;

    // Check if already initialized
    if (carouselWrapper.dataset.initialized === "true") {
      return;
    }

    const track = carouselWrapper.querySelector(".c-upsell-carousel-track");
    const slides = carouselWrapper.querySelectorAll(".c-upsell-carousel-slide");
    const prevBtn = carouselWrapper.querySelector(".c-upsell-carousel-prev");
    const nextBtn = carouselWrapper.querySelector(".c-upsell-carousel-next");
    const dots = carouselWrapper.querySelectorAll(".c-upsell-carousel-dot");

    if (!track || slides.length === 0) return;

    // Mark as initialized
    carouselWrapper.dataset.initialized = "true";

    // Get or initialize current slide position
    const carouselId =
      carouselWrapper.getAttribute("data-upsell-carousel") || "default";
    let currentSlide = carouselStates.get(carouselId) || 0;
    const totalSlides = slides.length;

    // Hide navigation buttons if only one slide
    if (totalSlides <= 1) {
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
      const dotsContainer = carouselWrapper.querySelector(
        ".c-upsell-carousel-dots"
      );
      if (dotsContainer) dotsContainer.style.display = "none";
      return;
    }

    function updateCarousel() {
      const slideWidth = track.offsetWidth;
      track.scrollTo({
        left: slideWidth * currentSlide,
        behavior: "smooth",
      });

      // Update dots
      dots.forEach((dot, index) => {
        if (index === currentSlide) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });

      // Update navigation buttons - hide instead of disable
      if (prevBtn) {
        if (currentSlide === 0) {
          prevBtn.style.display = "none";
        } else {
          prevBtn.style.display = "flex";
        }
      }
      if (nextBtn) {
        if (currentSlide === totalSlides - 1) {
          nextBtn.style.display = "none";
        } else {
          nextBtn.style.display = "flex";
        }
      }
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        if (currentSlide > 0) {
          currentSlide--;
          carouselStates.set(carouselId, currentSlide);
          updateCarousel();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        if (currentSlide < totalSlides - 1) {
          currentSlide++;
          carouselStates.set(carouselId, currentSlide);
          updateCarousel();
        }
      });
    }

    // Hide navigation buttons if only one slide
    if (totalSlides <= 1) {
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
    }

    // Dots navigation
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        currentSlide = index;
        carouselStates.set(carouselId, currentSlide);
        updateCarousel();
      });
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateCarousel();
      }, 250);
    });

    // Initialize
    updateCarousel();
  }

  // Upsell Add to Cart Functionality
  function initUpsellAddToCart() {
    const addToCartButtons = document.querySelectorAll(
      ".c-upsell-add-to-cart-btn"
    );

    addToCartButtons.forEach((button) => {
      // Handle click event
      button.addEventListener("click", async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const productId = this.getAttribute("data-product-id");
        const productHandle = this.getAttribute("data-product-handle");
        const buttonText = this.querySelector(".c-upsell-btn-text");

        if (!productId || this.classList.contains("disabled")) return;

        // Disable button during request
        this.classList.add("disabled");
        const originalText = buttonText.textContent;
        buttonText.textContent = "Adding...";

        try {
          // Add product to cart
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: productId,
              quantity: 1,
            }),
          });

          if (!response.ok) {
            throw new Error("Failed to add product to cart");
          }

          const data = await response.json();

          // Update button state
          this.classList.add("added");
          buttonText.textContent = "Added";
          this.classList.remove("disabled");

          // Trigger cart update event
          document.dispatchEvent(new CustomEvent("cart:updated"));

          // If there's a cart drawer or minicart, refresh it
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent("cart:refresh"));
          }

          // Reset button after 2 seconds (optional)
          setTimeout(() => {
            this.classList.remove("added");
            buttonText.textContent = originalText;
          }, 2000);
        } catch (error) {
          console.error("Error adding product to cart:", error);
          buttonText.textContent = "Error";
          this.classList.remove("disabled");

          // Reset after error
          setTimeout(() => {
            buttonText.textContent = originalText;
          }, 2000);
        }
      });

      // Handle keyboard accessibility (Enter and Space keys)
      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initUpsellCarousel();
      initUpsellAddToCart();
    });
  } else {
    initUpsellCarousel();
    initUpsellAddToCart();
  }

  // Re-initialize if carousel is added dynamically (but preserve state)
  const observer = new MutationObserver((mutations) => {
    // Only re-initialize if the carousel wrapper itself is added, not on every DOM change
    let shouldReinit = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          if (node.matches && node.matches("[data-upsell-carousel]")) {
            shouldReinit = true;
          }
          if (
            node.querySelector &&
            node.querySelector("[data-upsell-carousel]")
          ) {
            shouldReinit = true;
          }
        }
      });
    });

    if (shouldReinit) {
      initUpsellCarousel();
      initUpsellAddToCart();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// V_PSD_SEARCH_51 | Add to Cart Button in Search Results
(function () {
  "use strict";

  function initSearch51AddToCart() {
    const buttons = document.querySelectorAll(
      ".c-search51-add-to-cart:not([data-search51-bound])"
    );

    buttons.forEach(function (button) {
      button.setAttribute("data-search51-bound", "true");

      button.addEventListener("click", async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = this.getAttribute("data-variant-id");
        const textEl = this.querySelector(".c-search51-add-to-cart-text");

        if (!variantId || this.classList.contains("c-search51-disabled"))
          return;

        this.classList.add("c-search51-disabled");
        const originalText = textEl.textContent;
        textEl.textContent = "Adding...";

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (!response.ok) {
            throw new Error("Failed to add product to cart");
          }

          textEl.textContent = "Added";
          this.classList.remove("c-search51-disabled");

          document.dispatchEvent(new CustomEvent("cart:updated"));
          window.dispatchEvent(new CustomEvent("cart:refresh"));

          setTimeout(() => {
            textEl.textContent = originalText;
          }, 2000);
        } catch (error) {
          console.error("Error adding product to cart:", error);
          textEl.textContent = "Error";
          this.classList.remove("c-search51-disabled");

          setTimeout(() => {
            textEl.textContent = originalText;
          }, 2000);
        }
      });

      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSearch51AddToCart);
  } else {
    initSearch51AddToCart();
  }
})();

// C - Trivia Quiz
(function () {
  "use strict";

  var STORAGE_PREFIX = "c_trivia_";

  function initTriviaQuiz() {
    var quizEl = document.querySelector(".c-trivia-quiz");

    // No active question — start countdown on the upcoming-question empty state if present
    if (!quizEl) {
      var emptyCountdown = document.querySelector(
        ".c-trivia-empty .c-trivia-countdown-pill"
      );
      if (emptyCountdown)
        startCountdowns(document.querySelector(".c-trivia-empty"));
      return;
    }

    var handle = quizEl.dataset.questionHandle;
    var correctAnswer = quizEl.dataset.correctAnswer;
    var discountCode = quizEl.dataset.discount;
    var discountPrefix = quizEl.dataset.discountPrefix || "";
    var explanation = quizEl.dataset.explanation;
    var collectionUrl = quizEl.dataset.collectionUrl;
    var storageKey = STORAGE_PREFIX + handle;

    var optionBtns = quizEl.querySelectorAll(".c-trivia-option");
    var submitBtn = quizEl.querySelector(".c-trivia-submit");
    var resultPanel = quizEl.querySelector(".c-trivia-result");
    var resultCorrect = quizEl.querySelector(".c-trivia-result-correct");
    var resultWrong = quizEl.querySelector(".c-trivia-result-wrong");
    var answeredPanel = quizEl.querySelector(".c-trivia-answered");

    var selectedOption = null;

    // Check if user already answered this question
    var savedState = null;
    try {
      var raw = localStorage.getItem(storageKey);
      if (raw) savedState = JSON.parse(raw);
    } catch (e) {}

    if (savedState && savedState.answered) {
      lockOptionsUI(
        quizEl,
        savedState.selectedOption || savedState.selectedKey,
        savedState.wasCorrect,
        false
      );
      submitBtn.disabled = true;
      answeredPanel.hidden = false;

      var answeredShopLink = answeredPanel.querySelector(".c-trivia-shop-btn");
      if (answeredShopLink) {
        answeredShopLink.href = collectionUrl;
        answeredShopLink.textContent = "Explore The Best Deals";
      }

      // Hide header banner on return visit
      var container = quizEl.closest(".c-trivia-container");
      if (container) {
        var headerBanner = container.querySelector(".c-trivia-header-banner");
        if (headerBanner) headerBanner.style.display = "none";
      }

      startCountdowns(quizEl);
      return;
    }

    // Option selection — single select
    optionBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        optionBtns.forEach(function (b) {
          b.classList.remove("c-trivia-option--selected");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("c-trivia-option--selected");
        btn.setAttribute("aria-pressed", "true");
        selectedOption = btn.dataset.optionKey; // "a", "b", "c", or "d"
        submitBtn.disabled = false;
      });
    });

    // Submit
    submitBtn.addEventListener("click", function () {
      if (!selectedOption) return;

      var isCorrect = selectedOption === correctAnswer;

      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            answered: true,
            selectedOption: selectedOption,
            wasCorrect: isCorrect,
          })
        );
      } catch (e) {}

      lockOptionsUI(quizEl, selectedOption, isCorrect, true);
      submitBtn.disabled = true;
      resultPanel.hidden = false;

      if (isCorrect) {
        resultCorrect.hidden = false;

        // Populate correct answer text
        var correctBtn = quizEl.querySelector(
          '[data-option-key="' + correctAnswer + '"]'
        );
        var correctAnswerValueEl = resultCorrect.querySelector(
          ".c-trivia-correct-answer-value"
        );
        if (correctAnswerValueEl && correctBtn)
          correctAnswerValueEl.textContent = correctBtn.dataset.option;

        var explanationEl = resultCorrect.querySelector(
          ".c-trivia-result-explanation"
        );
        var discountEl = resultCorrect.querySelector(".c-trivia-discount-code");
        var discountPrefEl = resultCorrect.querySelector(
          ".c-trivia-discount-prefix"
        );
        var shopLink = resultCorrect.querySelector(".c-trivia-shop-btn");

        if (explanationEl) explanationEl.textContent = explanation;
        if (discountPrefEl) discountPrefEl.textContent = discountPrefix;
        if (discountEl) discountEl.textContent = discountCode;
        if (shopLink) {
          shopLink.href = collectionUrl;
          shopLink.textContent = "Shop The Best Deals Now";
        }

        // Hide countdown when correct
        var countdownWrapCorrect = resultPanel.querySelector(
          ".c-trivia-countdown-wrap"
        );
        if (countdownWrapCorrect) countdownWrapCorrect.style.display = "none";
      } else {
        resultWrong.hidden = false;

        // Populate correct answer text in wrong panel
        var correctBtnW = quizEl.querySelector(
          '[data-option-key="' + correctAnswer + '"]'
        );
        var correctAnswerValueElW = resultWrong.querySelector(
          ".c-trivia-correct-answer-value"
        );
        if (correctAnswerValueElW && correctBtnW)
          correctAnswerValueElW.textContent = correctBtnW.dataset.option;

        var wrongExplEl = resultWrong.querySelector(
          ".c-trivia-result-explanation"
        );
        if (wrongExplEl) wrongExplEl.textContent = explanation;

        var wrongShopLink = resultWrong.querySelector(".c-trivia-shop-btn");
        if (wrongShopLink) {
          wrongShopLink.href = collectionUrl;
          wrongShopLink.textContent = "Explore The Best Deals";
        }
      }

      startCountdowns(quizEl);
    });
  }

  // Highlight options after answer; showCorrect=true reveals navy/red styling, false just marks prior selection
  function lockOptionsUI(quizEl, selectedKey, wasCorrect, showCorrect) {
    var correctAnswer = quizEl.dataset.correctAnswer; // "a", "b", "c", or "d"
    var optionBtns = quizEl.querySelectorAll(".c-trivia-option");

    quizEl.classList.add("c-trivia-quiz--answered");

    // Swap header banner content in place (no hide/show — avoids layout jump)
    var container = quizEl.closest(".c-trivia-container");
    if (container) {
      var headerBanner = container.querySelector(".c-trivia-header-banner");
      if (headerBanner) {
        var newHeading = wasCorrect
          ? quizEl.dataset.successHeading
          : quizEl.dataset.failHeading;
        var newMascotUrl = wasCorrect
          ? quizEl.dataset.successMascot
          : quizEl.dataset.failMascot;

        var titleEl = headerBanner.querySelector(".c-trivia-header-title");
        var mascotEl = headerBanner.querySelector(".c-trivia-mascot");

        if (titleEl && newHeading) titleEl.textContent = newHeading;

        if (newMascotUrl) {
          if (mascotEl) {
            mascotEl.removeAttribute("srcset");
            mascotEl.src = newMascotUrl;
          } else {
            var img = document.createElement("img");
            img.className = "c-trivia-mascot";
            img.src = newMascotUrl;
            img.alt = "";
            img.setAttribute("aria-hidden", "true");
            img.width = 80;
            headerBanner.insertBefore(img, headerBanner.firstChild);
          }
        } else if (mascotEl) {
          mascotEl.remove();
        }
      }
    }

    optionBtns.forEach(function (btn) {
      var optKey = btn.dataset.optionKey; // "a", "b", "c", or "d"
      if (showCorrect) {
        if (optKey === correctAnswer) {
          btn.classList.add("c-trivia-option--correct");
        } else if (optKey === selectedKey && !wasCorrect) {
          btn.classList.add("c-trivia-option--wrong");
        }
      } else {
        if (optKey === selectedKey) {
          btn.classList.add("c-trivia-option--selected");
        }
      }
    });
  }

  // Start all countdown timers found within scope
  function startCountdowns(scope) {
    var countdownEls = scope.querySelectorAll(
      ".c-trivia-countdown-pill[data-end-date]"
    );
    countdownEls.forEach(function (el) {
      var endDateStr = el.dataset.endDate; // YYYY-MM-DD
      if (!endDateStr) return;

      var endDate = new Date(endDateStr + "T23:59:59");
      var hrsEl = el.querySelector(".c-trivia-countdown-hrs");
      var minsEl = el.querySelector(".c-trivia-countdown-mins");
      var secsEl = el.querySelector(".c-trivia-countdown-secs");

      function tick() {
        var diff = endDate - new Date();

        if (diff <= 0) {
          if (hrsEl) hrsEl.textContent = "00";
          if (minsEl) minsEl.textContent = "00";
          if (secsEl) secsEl.textContent = "00";
          return;
        }

        var totalSecs = Math.floor(diff / 1000);
        var hours = Math.floor(totalSecs / 3600);
        var minutes = Math.floor((totalSecs % 3600) / 60);
        var seconds = totalSecs % 60;

        if (hrsEl) hrsEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(minutes);
        if (secsEl) secsEl.textContent = pad(seconds);
        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTriviaQuiz);
  } else {
    initTriviaQuiz();
  }
})();

// V_PSD_PROD-CARD_50 | Free Shipping Tag on Product Cards — Var A (static)
(function () {
  "use strict";

  if (!("IntersectionObserver" in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: "free_shipping_badge_view_custom" });
        observer.unobserve(entry.target);
      }
    });
  });

  function observeBadges(root) {
    root
      .querySelectorAll("[data-free-shipping-badge]")
      .forEach(function (badge) {
        observer.observe(badge);
      });
  }

  function init() {
    observeBadges(document);

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-free-shipping-badge]")) {
            observer.observe(node);
          }
          if (node.querySelectorAll) {
            observeBadges(node);
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Product card value badge: fills the c-free-offer: tag badge (or falls back
// to parsing "Free [item]" out of the title) and fires a view event.
(function () {
  function parseFreeGift(title) {
    // Extract "Free [item]" from titles like "...with Free Second Battery by Andis".
    // The "by <vendor>" boundary is a lookahead (not consumed) so the matched span
    // excludes it, letting us strip just the free-item phrase from the title while
    // keeping the vendor name in place.
    var m = title.match(/\s*(?:with|and)\s+free\s+(.+?)(?=\s+by\s+\w|$)/i);
    if (!m) return null;
    return { text: "Free " + m[1].trim(), span: m[0] };
  }

  var viewObserver = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: "value_badge_view" });
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  function collect(root, selector) {
    var nodes = root.matches && root.matches(selector) ? [root] : [];
    if (root.querySelectorAll) {
      nodes = nodes.concat(
        Array.prototype.slice.call(root.querySelectorAll(selector))
      );
    }
    return nodes;
  }

  function processNode(node) {
    if (node.nodeType !== 1) return;

    collect(node, "[data-title-fallback]").forEach(function (badge) {
      var rawTitle = badge.getAttribute("data-title-fallback") || "";
      var parsed = parseFreeGift(rawTitle);
      badge.removeAttribute("data-title-fallback");
      if (!parsed) return;

      badge.textContent = "+ Includes " + parsed.text;
      badge.classList.remove("c-prod-card-52-badge--spacer");
      badge.removeAttribute("aria-hidden");
      badge.setAttribute("data-value-badge", "");

      // The free-item phrase now lives in the badge - drop it from the title
      // itself so it isn't shown twice.
      var badgeSlot = badge.closest(".c-prod-card-52-badge-slot");
      var titleEl = badgeSlot && badgeSlot.previousElementSibling;
      var isCardTitle =
        titleEl &&
        (titleEl.classList.contains("c-product-card__title-test-var-a") ||
          titleEl.classList.contains("product-card__title"));
      if (isCardTitle) {
        titleEl.textContent = titleEl.textContent
          .replace(parsed.span, "")
          .replace(/\s{2,}/g, " ")
          .trim();
      }
    });

    collect(node, "[data-value-badge]:not([data-observed])").forEach(function (
      badge
    ) {
      badge.setAttribute("data-observed", "1");
      viewObserver.observe(badge);
    });
  }

  function init() {
    processNode(document.body);

    // Watch for dynamically added cards (load-more / infinite scroll)
    var mutObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(processNode);
      });
    });
    mutObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

